import { AlertCircle, Check, CheckCheck, Clock, Mic } from "lucide-react";
import { EWhatsAppAck } from "@/services/whatsapp";
import { cn } from "@/lib/utils";

const ACK_LABELS: Record<number, string> = {
  [EWhatsAppAck.ERROR]: "Error al enviar",
  [EWhatsAppAck.PENDING]: "Pendiente",
  [EWhatsAppAck.SERVER]: "Enviado",
  [EWhatsAppAck.DEVICE]: "Entregado",
  [EWhatsAppAck.READ]: "Leído",
  [EWhatsAppAck.PLAYED]: "Reproducido",
};

export function MessageAck({ ack, className }: { ack?: EWhatsAppAck; className?: string }) {
  if (ack === undefined || ack === null) return null;

  const iconClass = cn("h-3.5 w-3.5 shrink-0", className);
  const label = ACK_LABELS[ack];

  switch (ack) {
    case EWhatsAppAck.ERROR:
      return <AlertCircle className={cn(iconClass, "text-destructive")} aria-label={label} />;
    case EWhatsAppAck.PENDING:
      return <Clock className={cn(iconClass, "text-muted-foreground")} aria-label={label} />;
    case EWhatsAppAck.SERVER:
      return <Check className={cn(iconClass, "text-muted-foreground")} aria-label={label} />;
    case EWhatsAppAck.DEVICE:
      return <CheckCheck className={cn(iconClass, "text-muted-foreground")} aria-label={label} />;
    case EWhatsAppAck.READ:
      return <CheckCheck className={cn(iconClass, "text-primary")} aria-label={label} />;
    case EWhatsAppAck.PLAYED:
      return <Mic className={cn(iconClass, "text-primary")} aria-label={label} />;
    default:
      return null;
  }
}
